<div class="dashboard-container">
  <div class="row">
    <!-- Card Movimientos por Tipo -->
    <div class="col">
      <mat-card appearance="outlined">
        <ngx-spinner
          [zIndex]="100"
          name="spCantidadPorTipo"
          bdColor="rgba(255,255,255,0.8)"
          size="default"
          color="#1a73e8"
          type="ball-atom"
          [fullScreen]="false"
        ></ngx-spinner>

        <mat-card-header class="card-header">
          <div class="header-content">
            <mat-icon class="header-icon">donut_large</mat-icon>
            <div class="header-text">
              <mat-card-title>Movimientos por Tipo</mat-card-title>
              <mat-card-subtitle>Distribución de movimientos según su tipo</mat-card-subtitle>
            </div>
          </div>
        </mat-card-header>

        <mat-card-content class="chart-content">
          <!-- Gráfico de Tipo -->
          <div class="chart-container" *ngIf="cantidadPorTipoDto.length > 0">
            <canvas
              #chartTipo
              id="chart-tipo"
              width="320"
              height="240">
            </canvas>
          </div>

          <!-- Resumen Tipo -->
          <div class="chart-summary" *ngIf="cantidadPorTipoDto.length > 0">
            <div class="summary-item">
              <mat-icon>swap_horiz</mat-icon>
              <span class="summary-label">Total de movimientos:</span>
              <span class="summary-value">{{ calcularCantidadTotalMovimientoPorTipo() }}</span>
            </div>
          </div>

          <!-- Sin datos Tipo -->
          <div class="no-data" *ngIf="cantidadPorTipoDto.length === 0">
            <mat-icon>analytics</mat-icon>
            <span>No hay datos de movimientos disponibles</span>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button [routerLink]="['/movimientos']">
            <mat-icon>list</mat-icon>
            Ver listado
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- Card Resumen de Actividad -->
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-header class="card-header">
          <div class="header-content">
            <mat-icon class="header-icon">trending_up</mat-icon>
            <div class="header-text">
              <mat-card-title>Resumen de Actividad</mat-card-title>
              <mat-card-subtitle>Estadísticas generales de movimientos</mat-card-subtitle>
            </div>
          </div>
        </mat-card-header>

        <mat-card-content class="chart-content">
          <!-- Estadísticas en cards -->
          <div class="stats-grid" *ngIf="cantidadPorTipoDto.length > 0">
            <div class="stat-card">
              <mat-icon class="stat-icon">category</mat-icon>
              <div class="stat-content">
                <span class="stat-number">{{ cantidadPorTipoDto.length }}</span>
                <span class="stat-label">Tipos de movimientos</span>
              </div>
            </div>

            <div class="stat-card">
              <mat-icon class="stat-icon">timeline</mat-icon>
              <div class="stat-content">
                <span class="stat-number">{{ calcularCantidadTotalMovimientoPorTipo() }}</span>
                <span class="stat-label">Total de registros</span>
              </div>
            </div>
          </div>

          <!-- Lista de tipos cuando hay datos -->
          <div class="types-list" *ngIf="cantidadPorTipoDto.length > 0">
            <h4>Tipos más frecuentes:</h4>
            <div class="type-item" *ngFor="let item of cantidadPorTipoDto.slice(0, 3)">
              <span class="type-name">{{ item.descripcion | titlecase }}</span>
              <span class="type-count">{{ item.cantidad }}</span>
            </div>
          </div>

          <!-- Sin datos -->
          <div class="no-data" *ngIf="cantidadPorTipoDto.length === 0">
            <mat-icon>analytics</mat-icon>
            <span>No hay estadísticas disponibles</span>
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button [routerLink]="['/movimientos']">
            <mat-icon>insights</mat-icon>
            Ver reportes
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
